import auth from "./auth";
import recorder from "./recorder";

export default { auth, recorder };
